export type ToastVariant = 'success' | 'error' | 'info'

export interface Toast {
  id: string
  variant: ToastVariant
  message: string
  durationMs: number
}

export interface ToastApi {
  success: (message: string, durationMs?: number) => void
  error: (message: string, durationMs?: number) => void
  info: (message: string, durationMs?: number) => void
  dismiss: (id: string) => void
}

export const DEFAULT_SUCCESS_MS = 3000
export const DEFAULT_ERROR_MS = 6000
export const DEFAULT_INFO_MS = 4000
